module.exports = __webpack_public_path__ + "img/form-bg-img.fe8d7675.png";